import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@hotjar/hotsauce';
import type { PageVisitEvent } from '@hotjar/webapp/features/Playbacks/types';
import { getMinutesAndSeconds } from '@hotjar/webapp/lib/getMinutesAndSeconds';
import { useStore } from '../../../../../store/player/context';
import { jumpTo } from '../../../../Playbacks/utils';
import { TimeButton } from './styles';

export const Time = ({ event }: { event: PageVisitEvent }): JSX.Element => {
  const { t } = useTranslation();

  const playerStore = useStore();
  const jumpToTime = useCallback(
    () => jumpTo(playerStore, event.time_in_timeline - 1000),
    [playerStore, event],
  );

  return (
    <Tooltip text={t('common:player.console-go-to-time')}>
      <TimeButton onClick={jumpToTime}>{getMinutesAndSeconds(event.time_in_timeline)}</TimeButton>
    </Tooltip>
  );
};
